import { createControlId } from '@avantia/questionset-model';
import jQuery from 'jquery';

import { triggerNavigationBarEvent } from '../../../actions/eventActions';
import { HpTriggerNavigationBarEventProps } from '../../../actions/eventActionTypes';
import { HpOnMouseEvent } from '../../../types';
import { createTabItems, getPercentCompleted, setDocumentTitle } from './navigationTabControlCommon';
import { HpNavigationTabControlProps } from './navigationTabControlTypes';

export function NavigationTabAllSectionsControl({
  id,
  activeKey,
  highestTouchedKey,
  isJourneyComplete,
  items,
  eventDetail,
  hasError,
  onClick
}: HpNavigationTabControlProps): JSX.Element | null {
  if (items.length <= 1) {
    return null;
  }

  const { activeIndex, highestTouchedIndex, percentCompleted } = getPercentCompleted({
    items,
    activeKey,
    highestTouchedKey
  });

  setDocumentTitle(items[activeIndex]);

  const stateClick: HpOnMouseEvent = (event, detail) => {
    const props: HpTriggerNavigationBarEventProps = {
      getEvent: () => event,
      actionType: 'select',
      elementType: 'menu'
    };

    triggerNavigationBarEvent(props);

    if (jQuery(event.target).closest('.av-current').length !== 1) {
      onClick(event, detail);
    }
  };

  return (
    <div className="av-timeline av-timeline-all-sections" id={createControlId({ questionId: id })}>
      <div className="av-timeline-line">
        <div className="av-timeline-line-complete" style={{ width: `${percentCompleted}%` }}></div>
        <div className="av-timeline-line-incomplete" style={{ width: `${100 - percentCompleted}%` }}></div>
      </div>
      <ul>
        {createTabItems({
          items,
          eventDetail,
          activeIndex,
          highestTouchedIndex,
          isJourneyComplete,
          hasError,
          onClick: stateClick
        })}
      </ul>
    </div>
  );
}
